/**
 * Centralized Typography Tokens for Autobet
 * Defines typography hierarchy, font families, font weights, and scale.
 */

export const fontFamilies = {
  primary: "'Poppins', 'Roboto', 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  secondary: "'Roboto', sans-serif",
  heading: "'Poppins', 'Roboto', sans-serif",
  cursive: "'Dancing Script', cursive",
  monospace: "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
};

export const typography = {
  fontFamily: fontFamilies.primary,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  fontWeightExtraBold: 800,

  h1: {
    fontFamily: fontFamilies.heading,
    fontWeight: 700,
    fontSize: "3.75rem", // 60px (matching Main.css h1)
    lineHeight: 1.1,
    letterSpacing: "-0.02em",
    color: "#002a33",
  },
  h2: {
    fontFamily: fontFamilies.heading,
    fontWeight: 700,
    fontSize: "2.1875rem", // 35px (matching Main.css h2)
    lineHeight: 1.3,
    letterSpacing: "-0.01em",
    color: "#002a33",
  },
  h3: {
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    fontSize: "1.5rem", // 24px (matching Main.css h3)
    lineHeight: 1.2,
    color: "#002a33",
  },
  h4: {
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    fontSize: "1.375rem", // 22px (matching Main.css h4)
    lineHeight: 1.25,
    color: "#002a33",
  },
  h5: {
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    fontSize: "1.125rem", // 18px
    lineHeight: 1.4,
    color: "#002a33",
  },
  h6: {
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    fontSize: "1rem", // 16px
    lineHeight: 1.4,
    color: "#002a33",
  },
  subtitle1: {
    fontSize: "1.125rem",
    fontWeight: 500,
    lineHeight: 1.5,
    color: "#6c757d",
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.57,
    color: "#6c757d",
  },
  body1: {
    fontSize: "1rem",
    lineHeight: 1.625,
    color: "#002a33",
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: 1.5,
    color: "#6c757d",
  },
  button: {
    fontFamily: fontFamilies.heading,
    fontWeight: 600,
    fontSize: "0.9375rem",
    lineHeight: 1.5,
    textTransform: "none", // Avoid aggressive uppercase
    letterSpacing: "0.02em",
  },
  caption: {
    fontSize: "0.75rem",
    lineHeight: 1.5,
    color: "#a1aed4",
  },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: 1.5,
    textTransform: "uppercase",
    letterSpacing: "0.08em",
  },


  homeSection: {
    headerBottomMargin: { xs: 4, md: 5 },
    headerContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 0,
    },
    eyebrow: {
      fontSize: { xs: "10px", sm: "11px", md: "12px", lg: "12px" },
      fontWeight: 600,
      letterSpacing: "1.5px",
      lineHeight: 1.2,
      textTransform: "uppercase",
      margin: 0,
      mb: "12px",
      display: "flex",
      alignItems: "center",
      gap: { xs: "6px", sm: "11px" },
      "&::before": {
        content: '""',
        width: "30px",
        "@media (max-width: 600px)": {
          width: "18px",
        },
        height: "2px",
        borderRadius: "2px",
        flexShrink: 0,
      }
    },
    heading: {
      fontFamily: fontFamilies.heading,
      fontSize: { xs: "26px", sm: "28px", md: "32px" },
      fontWeight: 800,
      letterSpacing: "-0.02em",
      lineHeight: 1.1,
      margin: 0,
      mb: 0,
    },
    description: {
      fontSize: { xs: "12px", sm: "14px", md: "14px", lg: "14px" },
      fontWeight: 400,
      lineHeight: 1.6,
      margin: 0,
      mt: "16px",
    }
  }
};

export default typography;
